import React from 'react';

import App from '../App';
import CallexLoader from '../components/CallexLoader';
import useEnterpriseSingleTab from './useSafeSingleTab';
import SessionBlocked from '../components/SessionBlocked';
import { useUserDetails } from '../store/slices/authSlice';

const RootGuard = () => {
  const userDetails = useUserDetails();
  const status = useEnterpriseSingleTab(userDetails?.type);

  if (status === null) {
    return <CallexLoader />;
  }

  if (status === true) {
    return <SessionBlocked />;
  }

  return <App />;
};

export default RootGuard;
